module.exports = __webpack_public_path__ + "media/images/blackboard_logo_square_36-32317ee5991c34ec25af394187fbf219.png";